<div class="bc-accordion" tabindex="-1" [attr.data-automation-id]="'bc-accordion-panel'">
  <div class="panel-heading-tabs">
    <h4 class="panel-title panel-title-button" [attr.data-automation-id]="'active-conversations-button'" [ngClass]="{'active': isActiveConversationsPanelActive() }" (click)="panelOpen(accordionPanelStates.ACTIVE_CONVERSATIONS)">
      {{ 'bcAccordion.activePanel' | translate }} ({{ getActiveWorkitemCount() + (activeGenesysConversationCount$ | async) }})
      <workitem-activity-indicator [unansweredMessageCount]="getUnansweredMessageCount()"
                                   [secondsRemainingDisplay]="getSecondsRemainingDisplay()"
                                   [forceDisableRedDots]="isRedDotNotificationDisabled()"
                                   [optionalClassName]="'accordion'"></workitem-activity-indicator>
    </h4>

    <ng-container *ngIf="isBoldEnabled | async">
      <h4 class="panel-title panel-title-button"
          [attr.data-automation-id]="'past-conversations-button'"
          [ngClass]="{'active': isSearchConversationsPanelActive() }"
          (click)="panelOpen(accordionPanelStates.SEARCH_CONVERSATIONS)">
        {{ 'bcAccordion.searchPanel' | translate }}
      </h4>
      <h4 class="panel-title spacer" *ngIf="isQueueViewEnabled">
        <div class="open-button"
             (click)="goToQueuePage()"
             [attr.data-automation-id]="'bc-open-monitor-view'">
          <svg-icon icon="arrow-right"></svg-icon>
        </div>
      </h4>
    </ng-container>
  </div>

  <div class="panel-group-item" [hidden]="!isActiveConversationsPanelActive()">
    <app-work-item-list></app-work-item-list>
  </div>

  <ng-container *ngIf="isBoldEnabled | async">
    <div class="panel-group-item"
         [hidden]="!isSearchConversationsPanelActive()">
      <app-search-widget [isHybrid]='isHybrid | async'></app-search-widget>
    </div>
    <div *ngIf="isAgentStatsEnabled">
      <app-agent-stats></app-agent-stats>
    </div>
  </ng-container>
</div>
